<template lang="html">
  <v-card
    :id="'suggestions-' + idSuffix"
    :loading="loading"
    >
    <v-card
      v-for="(suggestion, index) in suggestions"
      :id="'suggestions-'+idSuffix+index"
      :key="suggestion.place_id"
      :class="suggestionClasses[index]"
      @mouseover="() => onMouseOverSuggestion(index)"
      @click="ev => onClickSuggestion(suggestion, ev)">
      <v-card-title class="suggestion-description">
        {{ suggestion.description }}
      </v-card-title>
    </v-card>
  </v-card>
</template>

<script>
import validator from './validator';
// import debounce from './debounce';
const debounce = (cb, timeout) => {
  let timer;
  return function () {
    // console.log('clearing timeout')
    clearTimeout(timer)
    // console.log('timeout cleared')
    timer = setTimeout(() => {
      // console.log('timeout complete')
      cb.apply(this, arguments)
      // console.log('func applied')
    }, timeout)
  }
}
export default {
  props: {
    value: {
      required: true,
      validator: v => validator(v, { string: true, nil: true, number: true })
    },
    idSuffix: {
      required: true,
      type: [String, Number],
      default: `${Math.random()*100}`
    },
    getSuggestions: {
      required: true,
      type: Function,
      default: () => alert('getSuggestions not implemented')
    },
    raiseError: {
      required: true,
      type: Function,
      default: () => alert('raiseError not implemented')
    },
    onSuggestionSelection: {
      required: true,
      type: Function,
      default: () => alert('onSuggestionSelection not implemented')
    },
    status: {
      required: true,
      validator: v => validator(v, { string: true, nil: true })
    },
    searchText: {
      required: true,
      validator: v => validator(v, { string: true, nil: true })
    },
    keyEvent: {
      required: true,
      validator: v => validator(v, { object: true })
    }
  },
  data: () => ({
    loading: false,
    suggestions: []
  }),
  computed: {
    suggestionClasses () {
      const pre = 'suggestion-'
      return this.suggestions.map((s, i) => {
        let suff = 'inactive'
        if (i === this.value) { suff = 'active' }
        return pre + suff
      })
    }
  },
  watch: {
    searchText (newVal, oldVal) {
      if (newVal && newVal.length > 3) {
        this.fetchSuggestions()
      }
    },
    keyEvent (val) {
      switch (val.value) {
        case 'Enter':
          val.ev.preventDefault()
          if (this.value !== null) {
            this.onSuggestionSelection(this.suggestions[this.value])
            this.suggestions = []
          }
          break;
        case 'ArrowDown':
          this.onChangeActiveSuggestion(1)
          break;
        case 'ArrowUp':
          this.onChangeActiveSuggestion(-1)
          break;
        case 'Escape':
          this.$emit('input', null)
          this.suggestions = []
          break;
        default:
          break;
      }
    }
  },
  methods: {
    fetchSuggestions () {
      this.loading = true
      if (!this.searchText || this.searchText.length < 3) {
        return
      }
      return debounce(value => this.getSuggestions(
        { input: value },
        this.onSuggestionsResponse
      ), 500)(this.searchText)
    },
    onSuggestionsResponse (suggestions, status) {
      if (status !== this.status) {
        this.raiseError('Autocomplete Suggestion Error: '+status)
      }
      this.loading = false
      this.suggestions = suggestions //|| []
    },
    onChangeActiveSuggestion (d) {
      const suggestionsCopy = this.suggestions.slice()
      const active = this.value
      let newVal;
      if (suggestionsCopy.length === 0) return;
      switch (d) {
        case 1:
          newVal = 0
          if (active !== null && active < suggestionsCopy.length - 1) {
            newVal = active + 1
          }
          this.$emit('input', newVal)
          break;
        case -1:
          newVal = suggestionsCopy.length - 1
          if (active) {
            newVal = active - 1
          }
          this.$emit('input', newVal)
          break;
        default:
          break;
      }
    },
    onMouseOverSuggestion (index) {
      if (this.suggestions.length === 0) return;
      this.$emit('input', index)
    },
    onClickSuggestion (suggestion, ev = null) {
      if (ev) ev.stopPropagation();
      this.suggestions = []
      return this.onSuggestionSelection(suggestion)
    }
  }
}
</script>

<style lang="css" scoped>
.v-card.v-sheet.theme--light.suggestion-active {
  background-color: grey;
}
</style>
